/**
 * Дескриптор справочника<para/>
 * Handbooks descriptor
 */
export class HandbookDescriptor {
    /**
     * Признак возможности к редактированию, TODO: задается только на клиенте<para/>
     * Sign of editing availability, TODO: can be set only in client
     */
    CanBeEdited: boolean = true;
    /**
     * Идентификатор<para/>
     * Identifier
     */
    Id: number = 0;
    /**
     * Наименование справочника на руссокм языке<para/>
     * Handbook name in russian
     */
    NameRu: string = '';
    /**
     * Наименование справочника на казахском языке<para/>
     * Handbook name in kazakh
     */
    NameKz: string = '';
    /**
     * Наименование справочника на английском языке<para/>
     * Handbook name in english
     */
    NameEn: string = '';
    /**
     * Класс иконки справочника<para/>
     * Handbook's icon class
     */
    Icon: string = '';
    /**
     * Путь к API<para/>
     * API path
     */
    ApiPath: string = '';

    static StaticList(): Array<HandbookDescriptor> {
        return [
            { Id: 1, CanBeEdited: false, ApiPath: 'Activities',           NameRu: 'Типы активности',      NameEn: 'Activity types',       NameKz: 'Қызмет түрлері',      Icon: 'fas fa-chart-line', },
            { Id: 2, CanBeEdited: true,  ApiPath: 'InformationSources',   NameRu: 'Источники информации', NameEn: 'Information sources',  NameKz: 'Ақпарат көздері',     Icon: 'fas fa-scroll', },
            { Id: 3, CanBeEdited: true,  ApiPath: 'SourceSystems',        NameRu: 'Системы-источники',    NameEn: 'Source systems',       NameKz: 'Жүйенің көздері',     Icon: 'fas fa-broadcast-tower', },
            { Id: 4, CanBeEdited: true,  ApiPath: 'MeasureUnits',         NameRu: 'Единицы измерения',    NameEn: 'Measure units',        NameKz: 'Өлшем бірлік',        Icon: 'fas fa-ruler-combined', },
            { Id: 5, CanBeEdited: false, ApiPath: 'Periodicities',        NameRu: 'Периодичности',        NameEn: 'Periodicities',        NameKz: 'Мерзімділік',         Icon: 'fas fa-hourglass-start', },
            { Id: 6, CanBeEdited: true,  ApiPath: 'ReferencedDocuments',  NameRu: 'Связанные документы',  NameEn: 'Linked documents',     NameKz: 'Байланысты құжаттар', Icon: 'fas fa-file-alt', },
            { Id: 7, CanBeEdited: true,  ApiPath: 'Regions',              NameRu: 'Регионы/районы',       NameEn: 'Regions/districts',    NameKz: 'Аймақтар/аудандар',   Icon: 'fas fa-map-signs', },
        ]
    }
}